/**
 * @generated SignedSource<<9616e526ed63460518841a4209c90070>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueStatusCategoryCell$data = {
  readonly id: string;
  readonly statusCategory: {
    readonly name: string | null | undefined;
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "IssueStatusCategoryCell";
};
export type IssueStatusCategoryCell$key = {
  readonly " $data"?: IssueStatusCategoryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatusCategoryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueStatusCategoryCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
};

(node as any).hash = "572521b74cb1e5c0d987e2f909d90e33";

export default node;
